<template>
  <KeyValuePair
    :label="label"
    :value="dateTimeStringForTooltip"
    class="location-card-date"
  >
    <template v-if="slots.label" #label>
      <slot name="label" />
    </template>

    <template #value>
      <div>{{ dateString }}</div>
      <div>{{ timeString }}</div>
    </template>
  </KeyValuePair>
</template>

<script lang="ts" setup>
import { DateTime } from 'luxon';
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';

import { renderDateTime } from '@rygen/rygen-ui/i18n';

import KeyValuePair from '@rygen/rygen-ui/components/ui/KeyValuePair.vue';

const props = defineProps({
  label: {
    type: String,
    default: () => '',
  },
  date: {
    type: Object as PropType<DateTime>,
    default: () => undefined,
  },
  usePlaceholder: {
    type: Boolean,
    default: () => false,
  },
});
const { label, date, usePlaceholder } = toRefs(props);

const slots = defineSlots<{
  label?: () => any;
}>();

const dateString = computed(() => {
  return renderDateTime(date?.value, {
    timeFormat: 'NONE',
    defaultValue: usePlaceholder.value ? '-' : '',
  });
});

const timeString = computed(() => {
  return renderDateTime(date?.value, {
    dateFormat: 'NONE',
    defaultValue: usePlaceholder.value ? '-' : '',
    timeZone: date?.value?.zoneName ?? undefined,
  });
});

const dateTimeStringForTooltip = computed(() => {
  const displayStr = [dateString.value, timeString.value]
    .filter((d) => !!d)
    .join('\n')
    .trim();
  return displayStr ? displayStr : '-';
});
</script>
